
export default function FoodInput({
    title, value, error, onChange, icon, clearErr
}){
    return (
        <div className="basket-form-input">
            <div>
                {title}
            </div>
            <div style={{borderColor: error ? 'red': null}}>
                <input 
                    type="tel"
                    onChange={e=>onChange(e.target.value)}
                    value={value}
                    onClick={
                        clearErr
                    }
                />
                <div>
                    {icon}
                </div>
            </div>
            <div>
                {error}
            </div>
        </div>
    )
}